// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"d9-z"};